import {fetchBaseQuery} from "@reduxjs/toolkit/query/react"
import type {StoreState} from "../features/store"
import {DOMAIN_API} from "./api"
import {applyAdminRequestHeaders} from "./apiHeaders"

export default fetchBaseQuery({
    baseUrl: DOMAIN_API,
    prepareHeaders: (headers, {getState}) => {
        const token = (getState() as StoreState).auth?.token
        if (token) headers.set("Authorization", `Bearer ${token}`)
        return applyAdminRequestHeaders(headers)
    }
})
